(() => {
  const initCollectionList = (section) => {
    if (!section || section.dataset.ajaxInitialized === 'true') return;
    section.dataset.ajaxInitialized = 'true';

    let abortController = null;

    const showSkeleton = () => {
      const grid = section.querySelector('[data-collection-list-grid]');
      const template = section.querySelector('[data-collection-list-skeleton-template]');
      if (!grid || !template) return;

      const skeleton = template.content.firstElementChild.cloneNode(true);
      skeleton.setAttribute('data-collection-list-grid', '');
      grid.replaceWith(skeleton);
    };

    section.collectionListLoadPage = async (href, push = true) => {
      if (abortController) abortController.abort();
      abortController = new AbortController();
      showSkeleton();

      const url = new URL(href, window.location.origin);
      const fetchUrl = new URL(url.toString());
      fetchUrl.searchParams.set('section_id', section.dataset.sectionId);

      try {
        const response = await fetch(fetchUrl.toString(), {
          signal: abortController.signal,
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!response.ok) throw new Error(`HTTP ${response.status}`);

        const html = await response.text();
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const nextContent = doc.querySelector('[data-collection-list-content]');
        const currentContent = section.querySelector('[data-collection-list-content]');
        if (!nextContent || !currentContent) throw new Error('Collection list content not found');

        currentContent.replaceWith(nextContent);
        if (push) window.history.pushState({ collectionListAjax: true }, '', url.toString());
      } catch (err) {
        if (err.name === 'AbortError') return;
        console.error('Collection list AJAX failed, falling back to reload:', err);
        window.location.href = href;
      }
    };

    section.addEventListener('click', (event) => {
      const link = event.target.closest('a[href]');
      if (!link) return;

      const url = new URL(link.href, window.location.origin);
      if (url.pathname !== window.location.pathname) return;
      if (!url.searchParams.has('page')) return;

      event.preventDefault();
      section.scrollIntoView({ behavior: 'smooth', block: 'start' });
      section.collectionListLoadPage(url.toString());
    });
  };

  const initAllCollectionLists = () => {
    document.querySelectorAll('[data-collection-list-section]').forEach(initCollectionList);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllCollectionLists, { once: true });
  } else {
    initAllCollectionLists();
  }

  if (!window.collectionListAjaxPopstateBound) {
    window.collectionListAjaxPopstateBound = true;
    window.addEventListener('popstate', () => {
      document.querySelectorAll('[data-collection-list-section]').forEach((section) => {
        if (typeof section.collectionListLoadPage === 'function') {
          section.collectionListLoadPage(window.location.href, false);
        }
      });
    });
  }
})();
